const BanzaEntityFavoritesPresets = {
  BanzaEntityFavorites: {
    attrs: {
      icon: "lets-icons:star-light",
      iconPressed: "lets-icons:star-duotone",
      iconColor: "#474554",
      iconPressedColor: "#726AF3"
    }
  }
};
export {
  BanzaEntityFavoritesPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFFbnRpdHlGYXZvcml0ZXNQcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFuemFFbnRpdHlGYXZvcml0ZXNQcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgICBCYW56YUVudGl0eUZhdm9yaXRlczoge1xuICAgICAgICBhdHRyczoge1xuICAgICAgICAgICAgaWNvbjogXCJsZXRzLWljb25zOnN0YXItbGlnaHRcIixcbiAgICAgICAgICAgIGljb25QcmVzc2VkOiBcImxldHMtaWNvbnM6c3Rhci1kdW90b25lXCIsXG4gICAgICAgICAgICBpY29uQ29sb3I6IFwiIzQ3NDU1NFwiLFxuICAgICAgICAgICAgaWNvblByZXNzZWRDb2xvcjogXCIjNzI2QUYzXCJcbiAgICAgICAgfSxcbiAgICB9XG59Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQWUsOEJBQUE7QUFBQSxFQUNYLHNCQUFzQjtBQUFBLElBQ2xCLE9BQU87QUFBQSxNQUNILE1BQU07QUFBQSxNQUNOLGFBQWE7QUFBQSxNQUNiLFdBQVc7QUFBQSxNQUNYLGtCQUFrQjtBQUFBLElBQ3JCO0FBQUEsRUFDVDtBQUNBOyJ9
